/**
 * Sent-mail tab: keep the address bar in step with the filter form so a
 * filtered view is bookmarkable. The form swaps via hx-get (?partial=content),
 * so the pushed URL is built here from the form fields, without the partial
 * parameter. Empty fields are omitted.
 */
export function sentFilterURL(baseURL: string, entries: Iterable<[string, unknown]>): string {
  const q = new URLSearchParams();
  for (const [k, v] of entries) {
    if (typeof v === "string" && v !== "") q.append(k, v);
  }
  const s = q.toString();
  return s ? `${baseURL}?${s}` : baseURL;
}

/** replace=true (search-as-you-type) rewrites the current entry instead of
 *  adding one per typing pause, so Back doesn't step through half-typed
 *  searches. */
export function pushSentFilterURL(form: HTMLFormElement, baseURL: string, replace = false): void {
  const entries = Array.from(new FormData(form).entries()) as Array<[string, unknown]>;
  const url = sentFilterURL(baseURL, entries);
  if (replace) history.replaceState({}, "", url);
  else history.pushState({}, "", url);
}
